import styles from './DiscountBadge.module.css'
import clsx from 'clsx'
import { BasicStyledComponent, DSDealPrice } from 'shared-definitions/types'

interface DiscountBadgeProps extends BasicStyledComponent {
  price: DSDealPrice
}

const DiscountBadge: React.VFC<DiscountBadgeProps> = ({ className, price }) => {
  if (!price.discount || !price.current) {
    return null
  }

  return (
    <div className={clsx(styles.container, className)}>
      <span className={styles.discountPercent}>
        {price.discountPercent}
        {'%'}
      </span>
      {' off'}
    </div>
  )
}

export default DiscountBadge
